import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Files, FileType, StatusOTA } from 'src/app/core/models/files.model';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { FilesService } from 'src/app/core/services/files.service';
import {
  HttpErrorResponse,
  HttpEventType,
  HttpResponse,
} from '@angular/common/http';
import { AuthService } from 'src/app/core/services/auth.service';
import { User } from 'src/app/core/models/persons.model';
import { DatePipe } from '@angular/common';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import { CommandsService } from 'src/app/core/services/command.service';
import { CommandToSend, Timeout } from 'src/app/core/models/commands.model';
import { MaxtrackService } from 'src/app/core/services/maxtrack.service';

@Component({
  selector: 'app-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss'],
  providers: [DatePipe],
})
export class FilesComponent implements OnInit {
  constructor(
    private modalService: NgbModal,
    private filesService: FilesService,
    private authService: AuthService,
    public datePipe: DatePipe,
    public toastService: ToastService,
    public commandService: CommandsService,
    private maxtrackService: MaxtrackService
  ) {
    this.user = this.authService.currentUserValue;
  }
  user: User;
  files: Files[] = [];
  filesFilter: Files[] = [];
  filesType: FileType[] = [
    {
      id: 1,
      name: 'FT_PROFILE',
      allowedSendInTheHand: false,
      allowedInsertInTheHand: false,
    },
  ];
  filterFileType: number = 1;
  filterFileProduction: any = undefined;
  newFile: Files = new Files();
  loadingFile = false;
  selectedFiles: any;
  currentFile: any;
  errorMsg = '';
  message = '';
  circularProgressiveWait: boolean = false;
  filterName: String = '';
  fileProfileContents: string = '';
  fileProfileName: string = '';
  prettyProfileFile: string = '0';
  orderbytimestampOTAAsc: boolean = true;
  orderbypercentAsc: boolean = true;

  public timeOutKeys: any = Object.values(Timeout).slice(
    0,
    Object.keys(Timeout).length / 2
  );

  public timeOutValues: any = Object.values(Timeout).slice(
    Object.keys(Timeout).length / 2,
    Object.keys(Timeout).length
  );

  sendFileCommand: sendFileCommand = new sendFileCommand();

  public async onFileSelected(event: any) {
    const file: File = event.target.files[0];

    this.loadingFile = true;
    this.newFile.formData.append('file', file);
  }

  public config: DropzoneConfigInterface = {
    clickable: true,
    autoReset: null,
    errorReset: null,
    maxFiles: 1,
  };

  statusOTA: StatusOTA[] = [];
  statusOTAManufactor: string = 'suntech';

  ngOnInit(): void {
    this.circularProgressiveWait = true;
    this.filesService.getFilesType().subscribe((response: FileType[]) => {
      this.filesType = response;
      this.circularProgressiveWait = false;
    });
    this.getFiles(this.filterFileType);
  }

  filterList() {
    this.filesFilter = this.files.filter((item: Files) => {
      return (
        item.name.toLowerCase().search(this.filterName.toLocaleLowerCase()) > -1
      );
    });
    if (this.filterFileProduction != undefined) {
      this.filesFilter = this.files.filter((item: Files) => {
        return item.production == this.filterFileProduction;
      });
    }
  }

  returnFilePlaceholder(fileTypeId: number) {
    return this.filesType.filter((item: FileType) => {
      return item.id == fileTypeId;
    })[0].placeholder;
  }

  returnAllowedSendFileType(fileTypeId: number) {
    return (
      this.filesType.filter((item: FileType) => {
        return item.id == fileTypeId && item.allowedSendInTheHand;
      }).length > 0
    );
  }
  returnAllowedInsertFileType(): FileType[] {
    return this.filesType.filter((item: FileType) => {
      return item.allowedInsertInTheHand;
    });
  }
  returnFileExtension(fileTypeId: number) {
    return this.filesType.filter((item: FileType) => {
      return item.id == fileTypeId;
    })[0].extension;
  }
  returnFileTypeName(fileTypeId: number) {
    if (fileTypeId != null) {
      return this.filesType.filter((item: FileType) => {
        return item.id == fileTypeId;
      })[0].name;
    } else {
      return undefined;
    }
  }

  getFiles(fileTypeId: number) {
    if (fileTypeId != null) {
      this.circularProgressiveWait = true;
      this.filesFilter = [];
      this.files = [];
      this.filesService.getFiles(fileTypeId).subscribe(
        (response: Files[]) => {
          this.files = response;
          this.files.forEach((item: Files) => {
            item.createDate = this.datePipe.transform(
              new Date(
                Date.parse(
                  item.createDate != undefined ? item.createDate.toString() : ''
                )
              ).toUTCString(),
              'dd-MM-yyyy HH:mm:ss'
            )!;
          });
          this.filesFilter = this.files;
          this.circularProgressiveWait = false;
        },
        (error: HttpErrorResponse) => {
          this.toastService.show(
            'Erro ao carregar arquivos - ' + error.message,
            {
              classname: 'bg-danger text-center text-white',
              delay: 10000,
            }
          );
          this.circularProgressiveWait = false;
        }
      );
    }
  }
  selectFile(event: any): void {
    if (event != null) {
      this.selectedFiles = event.target.files;
      this.newFile.fileSize = this.selectedFiles.item(0).size;
    }
  }
  sendFile() {
    var responseStatusCommand = [];
    var serialResponseStatusNotOk: string[] = [];

    let seriaisList = this.sendFileCommand.seriais.split(';');

    seriaisList.forEach((serialItem) => {
      this.circularProgressiveWait = true;
      var lastItem =
        seriaisList[seriaisList.length - 1] == serialItem ? true : false;

      var sendCommand = new CommandToSend();
      sendCommand.serial = serialItem.trim();
      sendCommand.timeout = this.timeOutValues[this.sendFileCommand.timeout];
      sendCommand.param = this.sendFileCommand.fileId.toString();
      sendCommand.tipo = 27;
      this.commandService
        .postSendCommand(sendCommand, this.user.userId)
        .subscribe(
          (response: any) => {
            if (
              (response != undefined && response.status == 1) ||
              (response != undefined && response.length == 0)
            ) {
              responseStatusCommand.push('ok');
            } else {
              serialResponseStatusNotOk.push(serialItem);
            }

            if (lastItem) {
              if (serialResponseStatusNotOk.length > seriaisList.length) {
                this.circularProgressiveWait = false;
                this.toastService.show(
                  'Erro ao enviar comandos:' +
                    serialResponseStatusNotOk.join(';'),
                  {
                    classname: 'bg-warning text-center text-white',
                    delay: 10000,
                  }
                );
              } else {
                if (serialResponseStatusNotOk.length > 0) {
                  this.circularProgressiveWait = false;
                  this.toastService.show(
                    'Alguns comandos não foram enviados:' +
                      serialResponseStatusNotOk.join(';'),
                    {
                      classname: 'bg-warning text-center text-white',
                      delay: 10000,
                    }
                  );
                } else {
                  this.circularProgressiveWait = false;
                  this.toastService.show('Comandos enviados', {
                    classname: 'bg-success text-center text-white',
                    delay: 2500,
                  });
                }
              }
            }
          },
          (error: HttpErrorResponse) => {
            serialResponseStatusNotOk.push(serialItem);

            if (lastItem) {
              if (serialResponseStatusNotOk.length > seriaisList.length) {
                this.circularProgressiveWait = false;
                this.toastService.show(
                  'Erro ao enviar comandos:' +
                    serialResponseStatusNotOk.join(';'),
                  {
                    classname: 'bg-warning text-center text-white',
                    delay: 10000,
                  }
                );
              } else {
                if (serialResponseStatusNotOk.length > 0) {
                  this.circularProgressiveWait = false;
                  this.toastService.show(
                    'Alguns comandos não foram enviados:' +
                      serialResponseStatusNotOk.join(';'),
                    {
                      classname: 'bg-warning text-center text-white',
                      delay: 10000,
                    }
                  );
                }
              }
            }
          }
        );
    });
  }

  downloadFile(fileId: number) {
    this.filesService.downloadFile(fileId);
  }

  inactiveFile(fileId: number) {
    this.filesService.inactiveFile(fileId).subscribe(
      (response: any) => {
        this.toastService.show('Arquivo inativado com sucesso', {
          classname: 'bg-success text-center text-white',
          delay: 2500,
        });
        this.circularProgressiveWait = false;
      },
      (error: HttpErrorResponse) => {
        this.toastService.show('Erro ao inativar arquivo - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
        this.circularProgressiveWait = false;
      }
    );
  }

  changeProductionFlagFile(fileId: number, isProdution: any) {
    this.circularProgressiveWait = true;
    this.filesService.changeProductionFlagFile(fileId, isProdution).subscribe(
      (response: any) => {
        this.toastService.show('Flag produção alterada com sucesso', {
          classname: 'bg-success text-center text-white',
          delay: 2500,
        });
        this.ngOnInit();
      },
      (error: HttpErrorResponse) => {
        this.toastService.show(
          'Erro ao alterar a flag de proução no arquivo - ' + error.message,
          {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          }
        );
        this.circularProgressiveWait = false;
      }
    );
  }
  insertNewFile(): void {
    this.errorMsg = '';
    if (this.selectedFiles) {
      const file: File | null = this.selectedFiles.item(0);
      if (file) {
        this.circularProgressiveWait = true;

        this.newFile.fileName = file.name;
        this.newFile.fileSize = file.size;
        this.newFile.fileId = 1;
        this.newFile.isActive = true;
        this.newFile.email = this.user.email;
        this.currentFile = file;
        this.filesService
          .createFileInfo(this.newFile)
          .subscribe((response: any) => {
            this.filesService.fileUpload(this.currentFile, response).subscribe(
              (event: any) => {
                if (event.type === HttpEventType.UploadProgress) {
                  console.log(Math.round((100 * event.loaded) / event.total));
                  if (Math.round((100 * event.loaded) / event.total) == 100) {
                    this.circularProgressiveWait = false;
                    this.toastService.show('Arquivo carregado com sucesso', {
                      classname: 'bg-success text-center text-white',
                      delay: 2500,
                    });
                    this.filterFileType = this.newFile.fileTypeId;
                    this.getFiles(this.newFile.fileTypeId);
                    this.newFile = new Files();
                  }
                } else if (event instanceof HttpResponse) {
                  this.message = event.body.responseMessage;
                }
              },
              (error: HttpErrorResponse) => {
                this.toastService.show(
                  'Erro ao carregar arquivo - ' + error.message,
                  {
                    classname: 'bg-danger text-center text-white',
                    delay: 10000,
                  }
                );
                this.circularProgressiveWait = false;

                this.currentFile = undefined;
              }
            );
          });
      }

      this.selectedFiles = undefined;
    }
  }

  openModal(centerDataModal: any) {
    let indexFileType = this.filesType.findIndex((fileTypeAux: FileType) => {
      return fileTypeAux.id == this.filterFileType;
    });
    if (this.filesType[indexFileType]) {
      this.newFile.fileTypeId = 1;
    } else {
      this.newFile.fileTypeId = this.filterFileType;
    }

    this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }

  translateAndRequestProfile(fileId: number, fileType: String) {
    this.circularProgressiveWait = true;
    this.fileProfileContents = '';
    this.maxtrackService.translateProfileFile(fileId, fileType).subscribe(
      (response: any) => {
        this.fileProfileContents = JSON.parse(response.profileFile);
        this.circularProgressiveWait = false;
        this.toastService.show('Sucesso ao traduzir arquivo', {
          classname: 'bg-success text-center text-white',
          delay: 10000,
        });
      },
      (error: HttpErrorResponse) => {
        this.circularProgressiveWait = false;
        this.toastService.show('Erro ao traduzir arquivo - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }

  decodeTimestamp(timestamp: any) {
    try {
      return this.datePipe.transform(
        new Date(Number(timestamp)).toUTCString(),
        'dd-MM-yyyy HH:mm:ss'
      )!;
    } catch (error) {
      return '';
    }
  }
  orderByPercent() {
    if (this.orderbypercentAsc) {
      this.statusOTA = this.statusOTA.sort(
        (a: StatusOTA, b: StatusOTA) =>
          (Number(a.porcentagem) ?? 0) - (Number(b.porcentagem) ?? 0)
      );
    } else {
      this.statusOTA = this.statusOTA.sort(
        (a: StatusOTA, b: StatusOTA) =>
          (Number(b.porcentagem) ?? 0) - (Number(a.porcentagem) ?? 0)
      );
    }
  }

  orderByTimestamp() {
    if (this.orderbytimestampOTAAsc) {
      this.statusOTA = this.statusOTA.sort(
        (a: StatusOTA, b: StatusOTA) =>
          (Number(a.dataHoraUltimoPacoteRecebido) ?? 0) -
          (Number(b.dataHoraUltimoPacoteRecebido) ?? 0)
      );
    } else {
      this.statusOTA = this.statusOTA.sort(
        (a: StatusOTA, b: StatusOTA) =>
          (Number(b.dataHoraUltimoPacoteRecebido) ?? 0) -
          (Number(a.dataHoraUltimoPacoteRecebido) ?? 0)
      );
    }
  }

  searchOTA(seriais: any) {
    var serialList: any[] = seriais.replace(' ', '').split(';');
    this.statusOTA = [];
    this.circularProgressiveWait = true;
    serialList = serialList.filter((v, i, a) => a.indexOf(v) === i);
    this.filesService
      .getStatusOTA(serialList, this.statusOTAManufactor)
      .subscribe({
        next: (response: any) => {
          try {
            if (response.length > 0) {
              response.forEach((item: string) => {
                let itemJson = JSON.parse(item);
                let itemSeriais = Object.keys(itemJson);
                let valueJson = Object(new StatusOTA());
                let itemJsonKeys = Object.keys(valueJson);

                itemJsonKeys.forEach((itemJsonKeysItem: any) => {
                  if (itemJson[itemSeriais[0]][itemJsonKeysItem] != '') {
                    valueJson[itemJsonKeysItem] = {};
                    valueJson[itemJsonKeysItem] =
                      itemJson[itemSeriais[0]][itemJsonKeysItem];
                    console.log(`${itemSeriais[0]} - ${itemJsonKeysItem}`);
                  }
                });

                this.statusOTA.push(valueJson);
                this.circularProgressiveWait = false;
              });
            }
          } catch (error) {}
          this.orderByPercent();
          this.toastService.show('Status OTA requisitado com sucesso', {
            classname: 'bg-success text-center text-white',
            delay: 10000,
          });
          this.circularProgressiveWait = false;
        },
        error: (error: any) => {
          this.toastService.show(
            'Erro ao buscar status do OTA - ' + error.message,
            {
              classname: 'bg-danger text-center text-white',
              delay: 10000,
            }
          );
          this.circularProgressiveWait = false;
        },
      });
  }

  openModalSendFile(centerDataModal: any, fileId: number) {
    this.sendFileCommand = new sendFileCommand();
    this.sendFileCommand.timeout = '0';
    this.sendFileCommand.fileId = fileId;
    this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }
  openModalTranslate(centerDataModal: any, item: any) {
    let fileType: String = this.returnFileTypeName(item.fileTypeId) ?? '';
    this.translateAndRequestProfile(item.fileId, fileType);
    this.fileProfileName = `${item.fileId} - ${item.name}`;
    this.modalService.open(centerDataModal, {
      centered: true,
      scrollable: true,
      keyboard: true,
      windowClass: 'modal-holder',
    });
  }
  getBarColor(progress: number) {
    if (progress <= 10) {
      return 'red';
    } else if (progress <= 99) {
      return 'yellow';
    } else {
      return 'green';
    }
  }
  round(num: number, fractionDigits: number): number {
    return Number(num.toFixed(fractionDigits));
  }
}

export class sendFileCommand {
  seriais: string;
  timeout: string;
  fileId: number;

  constructor() {
    (this.seriais = ''), (this.timeout = '0'), (this.fileId = -1);
  }
}
